module.exports = __webpack_public_path__ + "img/bg_1.471036e4.png";